/** Rahmen der App: Saal, Kopfzeile mit dem Umschalter, Navigation, Meldungen. */

import { NavLink, Route, Routes } from "react-router-dom";
import { OWNER_NAME, OWNERS } from "../../shared/types";
import { Saal } from "./components/Regal";
import { useStore } from "./lib/store";
import { RegalSeite } from "./views/RegalSeite";
import { WirBeide } from "./views/WirBeide";
import { Empfehlungen } from "./views/Empfehlungen";
import { Ritual } from "./views/Ritual";
import { Rueckblick } from "./views/Rueckblick";
import { Werkstatt } from "./views/Werkstatt";
import { ImportSeite } from "./views/ImportSeite";
import { Erfassen } from "./views/Erfassen";
import { Papierkorb } from "./views/Papierkorb";

const SEITEN = [
  { pfad: "/", name: "Regal", exakt: true },
  { pfad: "/wir-beide", name: "Wir beide" },
  { pfad: "/empfehlungen", name: "Empfehlungen" },
  { pfad: "/ritual", name: "Bewerten" },
  { pfad: "/rueckblick", name: "Rückblick" },
  { pfad: "/erfassen", name: "Erfassen" },
  { pfad: "/werkstatt", name: "Werkstatt" },
  { pfad: "/import", name: "Import" },
  { pfad: "/papierkorb", name: "Papierkorb" },
];

function Meldungen() {
  const { meldungen, schliesse } = useStore();
  if (!meldungen.length) return null;
  return (
    <div className="meldungen">
      {meldungen.map((m) => (
        <div key={m.id} className={`meldung ${m.art}`} role="status">
          <span>{m.text}</span>
          <button
            className="klein"
            onClick={() => schliesse(m.id)}
            aria-label="Meldung schließen"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default function App() {
  const { owner, setOwner, modus, books } = useStore();

  return (
    <>
      <Saal />

      <header className="kopf">
        <h1 className="wortmarke">Die Bibliothek</h1>
        <nav className="navi">
          {SEITEN.map((s) => (
            <NavLink
              key={s.pfad}
              to={s.pfad}
              end={s.exakt}
              className={({ isActive }) => (isActive ? "aktiv" : "")}
            >
              {s.name}
            </NavLink>
          ))}
        </nav>
        <nav className="wer" aria-label="Regal wählen">
          {OWNERS.map((o) => (
            <button
              key={o}
              aria-pressed={owner === o}
              onClick={() => setOwner(o)}
            >
              {OWNER_NAME[o]}
            </button>
          ))}
        </nav>
      </header>

      {modus === "vorschau" && (
        <div className="buehne" style={{ paddingBottom: 0 }}>
          <div
            className="karte"
            style={{ borderLeft: "3px solid var(--warn)", marginTop: 12 }}
          >
            <strong>Vorschau ohne Server.</strong>{" "}
            <span
              className="lauftext"
              style={{ display: "inline", fontSize: 14 }}
            >
              Der Worker antwortet nicht, deshalb kommen die {books.length}{" "}
              Bände aus der Datei books.json. Anschauen geht, Ändern nicht.
              Starten: <code>npm run dev</code> im Ordner <code>worker/</code>.
            </span>
          </div>
        </div>
      )}

      <main className="buehne">
        <Routes>
          <Route path="/" element={<RegalSeite />} />
          <Route path="/wir-beide" element={<WirBeide />} />
          <Route path="/empfehlungen" element={<Empfehlungen />} />
          <Route path="/ritual" element={<Ritual />} />
          <Route path="/rueckblick" element={<Rueckblick />} />
          <Route path="/werkstatt" element={<Werkstatt />} />
          <Route path="/import" element={<ImportSeite />} />
          <Route path="/erfassen" element={<Erfassen />} />
          <Route path="/papierkorb" element={<Papierkorb />} />
          <Route
            path="*"
            element={
              <p className="lauftext" style={{ marginTop: 60 }}>
                Diese Seite gibt es nicht.
              </p>
            }
          />
        </Routes>
      </main>

      <footer className="buehne" style={{ paddingTop: 0, paddingBottom: 60 }}>
        <p
          className="klein"
          style={{ fontSize: 9.5, lineHeight: 1.8, opacity: 0.55 }}
        >
          Saal-Fotografien: Klementinum — Václav Jiroušek, CC BY-SA 4.0 · Stift
          Melk — Jorge Royan, CC BY-SA 3.0 · Trinity College Long Room — CC
          BY-SA 4.0 · Regalbretter: Kirschholzbrett — Dietmar Rabich, CC BY-SA
          4.0, alle Wikimedia Commons. Buchumschläge sind Eigentum der
          jeweiligen Verlage.
        </p>
      </footer>

      <Meldungen />
    </>
  );
}
